import { useContext, useEffect, useRef, useState } from "react";
import useSmartState from "../../../common/hooks/useSmartState";
import { SmartContext } from '../../../library/Core/SmartContext';
import { Dropdown, Modal } from "bootstrap";
import { axiosClient } from "../../../library/Service/axiosClient";
import useInternalAdminReports from "../reports/useInternalAdminReports";

const BATCH_SIZE = 10;
const DEFAULT_SORT_COLUMN = 'createdAt';
const DEFAULT_SORT_DIRECTION = 'desc';

const ProfileLevelDataGrid = () => {
    const { state, dispatch } = useContext(SmartContext);
    const { setStateValue } = useSmartState();
    const [sortedStudents, setSortedStudents] = useState<string[]>([]);
    const [visibleStudents, setVisibleStudents] = useState(state.data.alumniList.slice(0, 10));
    const loadMoreRef: any = useRef();
    const dropdownRef = useRef(null);
    const [sortColumn, setSortColumn] = useState(DEFAULT_SORT_COLUMN);
    const [sortDirection, setSortDirection] = useState(DEFAULT_SORT_DIRECTION);
    const allRows = [...state.data.alumniList] ?? [];
    const [isEditMode, setIsEditMode] = useState(false);
    const [syncing, setSyncing] = useState<Set<string>>(new Set()); // Track syncing states for each institute ID
    const { getFormattedDate } = useInternalAdminReports();

    useEffect(() => {
        console.log(`useEffect 1`);
        if (dropdownRef.current) {
            new (Dropdown as any)(dropdownRef.current);
        }
    }, []);

    useEffect(() => {
        console.log(`useEffect 2`);
        const sorted = [...allRows].sort(compareFunction);
        setSortedStudents(sorted);
    }, [state.data.alumniList, sortColumn, sortDirection]);

    useEffect(() => {
        console.log(`useEffect 3`);
        setVisibleStudents(sortedStudents.slice(0, BATCH_SIZE));
    }, [sortedStudents]);

    useEffect(() => {
        console.log(`useEffect 4`);
        const loadMoreObserver = new IntersectionObserver((entries) => {
            // Check if all students are already visible
            if (sortedStudents.length <= visibleStudents.length) {
                if (loadMoreRef.current) {
                    loadMoreObserver.unobserve(loadMoreRef.current); // Stop observing
                }
                return;
            }

            if (entries[0].isIntersecting) {
                const nextBatch = sortedStudents.slice(0, visibleStudents.length + BATCH_SIZE);
                setVisibleStudents([...nextBatch]);
            }
        });

        if (loadMoreRef.current) loadMoreObserver.observe(loadMoreRef.current);

        return () => {
            if (loadMoreRef.current) {
                loadMoreObserver.unobserve(loadMoreRef.current);
            }
        };
    }, [loadMoreRef, visibleStudents]);

    const isStringColumn = typeof visibleStudents[0]?.[sortColumn] === 'string';

    const compareFunction = (a: any, b: any) => {
        const aValue = a[sortColumn];
        const bValue = b[sortColumn];

        if (isStringColumn) {
            return sortDirection === 'asc'
                ? aValue?.localeCompare(bValue, undefined, { sensitivity: 'accent' })
                : bValue?.localeCompare(aValue, undefined, { sensitivity: 'accent' });
        } else {
            return sortDirection === 'asc' ? (aValue > bValue ? 1 : -1) : aValue < bValue ? 1 : -1;
        }
    };

    // const getActionNode = (row: any) => {
    //     const actions = config['ROW_ACTION'];
    //     return actions.length > 1 ? (
    //         <ActionSettings id={row} actions={getValidActions(row?.isActive)} onClick={handleAction} />
    //     ) : (
    //         <a className="btn-update" href={config['UPDATE_ACTION_LINK'](row.uuid)} target="_blank" rel="noopener noreferrer">
    //             Update
    //         </a>
    //     );
    // };

    const syncNow = async (instituteId: string) => {
        if (syncing.has(instituteId)) return; // Prevent multiple clicks while syncing
        const updatedSyncing = new Set(syncing); // Create a new set to avoid mutation of state
        updatedSyncing.add(instituteId); // Add to syncing
        setSyncing(updatedSyncing);
    
        try {
            const response = await axiosClient().get(`${process.env.REACT_APP_ALUMNI_MATCH_SERVER}/update-level-and-segment/${instituteId}`);
            if (response?.status === 200) {
                alert(response?.data?.message);
            }
        } catch (error) {
            console.error("Error syncing:", error);
        } finally {
            const updatedSyncing = new Set(syncing); // Create a new set for state update
            updatedSyncing.delete(instituteId); // Remove from syncing
        }
    };

    const isOlderThan15Days = (dateString: string | null | undefined) => {
        if (!dateString || dateString.trim() === '') return true; 

        const logDate = new Date(dateString);
        if (isNaN(logDate.getTime())) return true; 

        const currentDate = new Date();
        const timeDifference = currentDate.getTime() - logDate.getTime();
        const daysDifference = timeDifference / (1000 * 3600 * 24);
        return daysDifference > 15;
    };


return (
        <>
            <div className="table-responsive attendee_dtl">
                <div>Found {allRows.length} rows</div>
                <table className="table table-hover">
                    <thead>
                        <tr>
                            <th>Institute Name</th>
                            <th>Created At</th>
                            <th>Updated At</th>
                            <th>Action</th>
                        </tr>
                    </thead>
                <tbody>
                     {visibleStudents.map((row: any) => (
                         <tr key={row.id}>
                            <td>{row.instituteName}</td>
                            <td>{getFormattedDate(row.createdAt)}</td>
                            <td>{getFormattedDate(row.updatedAt)}</td>
                             <td>
                                <div className="radio-group d-flex flex-column align-items-start lbl_orange font-14 font-500">
                                    <button
                                        disabled={syncing.has(row.id) || !(!row.createdAt || isOlderThan15Days(row.createdAt))}
                                        onClick={() => syncNow(row.id)}
                                        className="btn btn-green"
                                    >
                                        <span>{"Sync Now"}</span>
                                    </button>
                                </div>
                                </td>                         
                            </tr>
                             ))}
                      <tr ref={loadMoreRef} />
                </tbody>
            </table>
            </div>
        </>
    );
};

export default ProfileLevelDataGrid;
